import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RIFERIMENTI_UI } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolRiferimentiUiState extends EntityState<IID_OL_RIFERIMENTI_UI, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_RIFERIMENTI_UI })
@InterfaceDataStore(InterfaceName.OLO_RIFERIMENTI_UI)
export class IIDolRiferimentiUiStore extends EntityStore<IIDolRiferimentiUiState> {
  constructor() {
    super([]);
  }
}
